// Spec §7 masking & formatting rules.

// "ye••••@gmail.com" - first 2 characters + •••• + domain.
export const maskEmail = (email) => {
  if (!email || !email.includes('@')) return email
  const [local, domain] = email.split('@')
  return `${local.slice(0, 2)}••••@${domain}`
}

// "0803•••3405" - first 4 digits + ••• + last 4 digits. The spec shows a few cosmetic
// variants of this same mask across contexts (spacing differs); we use one consistent
// format everywhere.
export const maskPhone = (digits) => {
  if (!digits || digits.length < 8) return digits
  return `${digits.slice(0, 4)}•••${digits.slice(-4)}`
}

// Always the ₦ sign, never "N50". `showDecimals` for exact transfer amounts (₦50.00);
// omitted for round limit/summary amounts (₦50, ₦25,000).
export const formatNaira = (amount, showDecimals = false) => {
  const value = Number(amount) || 0
  return `₦${value.toLocaleString('en-NG', {
    minimumFractionDigits: showDecimals ? 2 : 0,
    maximumFractionDigits: showDecimals ? 2 : 0,
  })}`
}

// Ported from the legacy TransferConfirmationScreen.js: sessions with no fixed
// authorizationAmount show a min–max range instead of guessing a single number.
export const formatAuthorizationAmount = (authorizationAmount, minAmount, maxAmount) => {
  if (authorizationAmount != null) {
    return { displayAmount: formatNaira(authorizationAmount, true), displayAmountLabel: 'Amount to transfer' }
  }
  return {
    displayAmount: `${formatNaira(minAmount)} – ${formatNaira(maxAmount)}`,
    displayAmountLabel: 'Amount to transfer',
  }
}
